import Icon from 'veui/components/Icon'
import { IconArrowUpSolid } from 'dls-icons-vue'

Icon.register('arrow-up-solid', IconArrowUpSolid)
